import RightToolbar from '@/components/RightToolbar'
import Pagination from '@/components/Pagination'

export default function lazyUseComponent(app) {
    app.component('RightToolbar', RightToolbar)
    app.component('Pagination', Pagination)
}